import React from 'react';
import { NotAppBlackIcon, TwitterIcon, TelegramIcon } from './assets/index';

enum TaskStatus {
  Initial = 'initial',
  Check = 'check',
  Loading = 'loading',
  Done = 'done',
}

interface TaskUnitProps {
  task: {
    id: string;
    title: string;
    link: string;
    icon?: string;
    buttonText?: string;  
    done: boolean;
    status: TaskStatus; // Added status prop
  };
  onOpen: () => void; // Trigger when the task is opened
  onVerify: () => void; // Trigger when the task is verified
}

const TaskUnit: React.FC<TaskUnitProps> = ({ task, onOpen, onVerify }) => {
    //task.icon || NotAppBlackIcon; // Use default icon if none is provided

  task.icon = NotAppBlackIcon;
  if (task.link.includes("x.com") || task.link.includes("twitter.com")) {
    task.icon = TwitterIcon;
  } else if (task.link.startsWith("@")) {
    task.icon = TelegramIcon;
  }

  // const handleLink = (link: string) => {
  //   if (link.startsWith('@')) {
  //     link = `https://t.me/${link.slice(1)}`;
  //   }
  //   return link;
  // };

  const handleOpen = () => {
    onOpen(); // Trigger task open action
    //window.open(handleLink(task.link), '_blank'); // Open the link in a new tab
  };

  const handleVerify = () => {
    onVerify(); // Trigger verification action
  };

  const renderButtonContent = () => {
    switch (task.status) {
      case TaskStatus.Initial:
        return (
          <button onClick={handleOpen} className="button-tiny">
            {task.buttonText || 'Open'}
          </button>
        );
      case TaskStatus.Check:
        return (
          <button onClick={handleVerify} className="button-tiny">
            Check
          </button>
        );
      case TaskStatus.Loading:
        return (
          <button disabled className="button-tiny flex items-center">
            <span className="dot">•</span>
            <span className="dot">•</span>
            <span className="dot">•</span>
          </button>
        );
      case TaskStatus.Done:
        return (
          <button className="text-gray-500 hover:underline text-sm" disabled> {/*onClick={handleVerify}*/}
            Done
          </button>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex items-center justify-between p-2 border-b">
      {/* Icon Slot */}
      <div className="flex items-center">
        <div className="w-8 h-8 border border-gray-300 rounded-full overflow-hidden flex items-center justify-center mr-2">
          <img src={task.icon} alt="Task Icon" className="object-cover w-full h-full" />
        </div>
        <span className="text-lg">{task.title}</span>
      </div>
      
      {/* Button Slot */}
      {renderButtonContent()}
    </div>
  );
};

export default TaskUnit;
